<template>
  <v-dialog
    v-model="show"
    max-width="500px"
  >
    <v-card>
      <v-card-title class="text-h5">
        <v-icon
          class="mr-2"
          color="black"
        >
          mdi-cube-scan
        </v-icon>
        <span class="text-h5">{{ $localize('seeInAR') }}</span>
        <v-spacer />
        <v-btn
          icon
          @click="show = false"
        >
          <v-icon color="black">
            mdi-close
          </v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <span class="text-body1"> {{ $localize('qrcodeSummary') }} </span>
      </v-card-text>

      <v-card-text>
        <qrcode-vue
          class="row justify-center my-2"
          size="180"
          :value="url"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
  import QrcodeVue from 'qrcode.vue'

  export default {
    name: 'QrcodeAr',

    components: {
      QrcodeVue,
    },

    props: {
      value: Boolean,
      url: String,
    },

    computed: {
      show: {
        get () {
          return this.value
        },
        set (value) {
          this.$emit('input', value)
        },
      },
    },

  }
</script>
